import axios from 'axios';
import cfac22 from '../cfac22';


export function listSomePosts(uId, payload) {
  return new Promise((resolve, reject) => {
    Promise.resolve().then(() => {
      axios.
      post(`${cfac22('API_HOST_V2')}/feedPosts/listSomePosts`, payload, {
        headers: {

          'Content-Type': 'application/json',
          'Full-Url': window.location.href
        }, withCredentials: true
      }).
      then((result) => resolve(result.data)).
      catch((error) => reject(error));
    });
  });
}
